import React from "react";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { useFetchSecurities } from "../api/useFetchDisclosures";
import { LoadingSpinner } from "lib/Spinner";
//import { NotFound } from "pages/login/NotFound";
import { NotAvailable } from "lib/SimpleTable";
import { Form, ButtonGroup, Button } from "react-bootstrap";
import { useStateArr } from "lib/hooks/useStateArr";
import queryString from "query-string";
import { SecurityTable } from "./SecurityTable";
import { useHistory } from "react-router";
import { _t } from "app/i18n/i18n";

export const SecuritySelector = () => {
  const qs = useQueryParams();
  if (!qs.date || !qs.tickers || !qs.assetClass) return null;
  return <SecuritySelectorForm {...qs} />;
};

export const SecuritySelectorForm = ({ date, assetClass, tickers = "" }) => {
  const [securities, isLoading, err] = useFetchSecurities(date, assetClass, tickers);
  const [selectedSecurityIds, , add, remove] = useStateArr([]);
  const history = useHistory();
  const onSelectSecurity = (row, checked) => (checked ? add(row.securityID) : remove(row.securityID));

  if (isLoading) return <LoadingSpinner />;
  if (err) return <NotAvailable />;
  if (securities.length === 1)
    history.replace(getStatementUrl({ date, assetClass, securityIds: [securities[0].securityID] }));

  const onSubmit = (event) => {
    event.preventDefault();
    history.push(getStatementUrl({ date, assetClass, securityIds: selectedSecurityIds.join(",") }));
  };

  return (
    <Form className="p-3 mb-3 clearfix border shadow" onSubmit={onSubmit}>
      <h4 className={`d-block pt-0 text-dark font-weight-lighter`}>{_t("Select Companies")}</h4>
      <SecurityTable securities={securities} onSelectSecurity={onSelectSecurity} />
      <SubmitButton disabled={!selectedSecurityIds.length} />
    </Form>
  );
};

const SubmitButton = ({ disabled }) => (
  <ButtonGroup className="mt-3 float-right">
    <Button variant="primary px-5" type="submit" disabled={disabled}>
      {_t("Proceed")}
    </Button>
  </ButtonGroup>
);

const getStatementUrl = (disclosureParams) => {
  window.scrollTo(0, 0);
  const qs = queryString.stringify(disclosureParams);
  return "/Disclosures/Statements?" + qs;
};
